var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{attrs:{"md":"4"}},[_c('label',[_vm._v("Unidad de negocio*")])]),_c('b-col',{attrs:{"md":"8"}},[_c('select-box',{attrs:{"value":_vm.ofertaBase.unidadNegocioId,"disabled":_vm.disabled,"options":_vm.unidadesNegocio},on:{"input":_vm.cambiarUnidadNegocio}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }